"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalT2 = void 0;
const BallScrewElement_1 = require("../BallScrewElement");
const Rows_1 = require("../Rows");
/**
 * Class to draw a screw
 */
class TerminalT2 extends BallScrewElement_1.BallScrewElement {
    /**
     * Draw a terminal
     * @param two
     * @param height
     * @param w
     * @param w3
     * @param thread
     * @param selected
     * @param position
     */
    constructor(two, height, w, w3, thread, selected, position = "right") {
        super();
        this.two = two;
        this.height = height;
        this.w = w;
        this.w3 = w3;
        this.selected = selected;
        this.position = position;
        this.thread = thread;
    }
    draw() {
        // Groups can take an array of shapes and/or groups.
        this.group = this.two.makeGroup();
        const part1 = 2 * this.scaleFactor;
        let width = this.w - this.w3;
        width = width - part1;
        const rect1 = this.two.makeRectangle(part1 / 2, 0, part1, this.height - 2);
        this.group.add(rect1);
        const rect2 = this.two.makeRectangle(rect1.translation.x + (part1 / 2) + (width / 2), 0, width, this.height);
        this.group.add(rect2);
        this.registerForQuote([rect2], "outercenter", 0, "Ø " + parseFloat(this.selected.d.toString()).toFixed(0).toString() + " h5", this.position === "left");
        const rect3 = this.two.makeRoundedRectangle(rect2.translation.x + (width / 2) + (this.w3 / 2), 0, this.w3, this.height, 0);
        this.registerForQuote([rect3], "outercenter", 0, this.selected.d5 + " -6g", this.position === "left");
        this.registerForQuote([rect3], this.position === "right" ? "bottom" : "top", 60, parseFloat(this.selected.W3.toString()).toFixed(0).toString(), this.position === "left", BallScrewElement_1.BallScrewElement.COLORQUOTE, true, true);
        this.group.add(rect3);
        this.registerForQuote([rect1, rect3], this.position === "right" ? "bottom" : "top", 100, parseFloat(this.selected.W.toString()).toFixed(0).toString(), this.position === "left", BallScrewElement_1.BallScrewElement.COLORQUOTE, false, false);
        this.registerForQuote([rect1, rect2], this.position === "right" ? "bottom" : "top", 60, "(" + parseFloat((this.selected.W - this.selected.W3).toString()).toFixed(0).toString() + ")", this.position === "left", BallScrewElement_1.BallScrewElement.COLORQUOTE, true, false);
        const xpart = rect3.translation.x + (this.w3 / 2);
        const thread1 = Rows_1.Rows.draw(this.two, rect3.translation.x - (this.w3 / 2), -(this.height / 2) + this.thread, xpart, -(this.height / 2) + this.thread, Rows_1.RowsStyle.Thread);
        this.group.add(thread1);
        const thread1ang = Rows_1.Rows.draw(this.two, rect3.translation.x - (this.w3 / 2) - (this.thread * 2), -(this.height / 2), rect3.translation.x - (this.w3 / 2), -(this.height / 2) + this.thread, Rows_1.RowsStyle.Thread);
        this.group.add(thread1ang);
        const thread2 = Rows_1.Rows.draw(this.two, rect3.translation.x - (this.w3 / 2), (this.height / 2) - this.thread, xpart, (this.height / 2) - this.thread, Rows_1.RowsStyle.Thread);
        this.group.add(thread2);
        const thread2ang = Rows_1.Rows.draw(this.two, rect3.translation.x - (this.w3 / 2) - (this.thread * 2), this.height / 2, rect3.translation.x - (this.w3 / 2), (this.height / 2) - this.thread, Rows_1.RowsStyle.Thread);
        this.group.add(thread2ang);
        return this.group;
    }
}
exports.TerminalT2 = TerminalT2;
